import { Button } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { ICursor } from '@/store/types/search.types';

export interface ICursorNavigationProps {
  handleCursor?: (cursor?: string) => void;
  cursor?: ICursor;
  hasLabel?: boolean;
}

function CursorNavigation({ cursor, handleCursor, hasLabel }: ICursorNavigationProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-end py-3 gap-5">
      <Button
        type="button"
        size="s"
        variant="ghost"
        icon="arrow_back_ios"
        onClick={() => handleCursor(cursor?.prev)}
        disabled={!cursor?.prev}
      >
        {hasLabel && t('pages.cores.previous')}
      </Button>
      <Button
        type="button"
        size="s"
        variant="ghost"
        icon="arrow_forward_ios"
        iconPosition="right"
        onClick={() => handleCursor(cursor?.next)}
        disabled={!cursor?.next}
      >
        {hasLabel && t('pages.cores.next')}
      </Button>
    </div>
  );
}

export default CursorNavigation;
